(function(){
  'use strict';
  var overlay,drawer,itemsEl,subtotalEl,recsList;
  var isOpen=false;
  function fmt(cents){return 'EGP '+(cents/100).toLocaleString('en',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function injectCod(){
    if(location.pathname.indexOf('/products/')<0)return;
    if(document.querySelector('.nz-cod'))return;
    var buy=document.querySelector('.buy-buttons-block')||document.querySelector('[class*="buy-buttons"]');
    if(!buy){setTimeout(injectCod,800);return;}
    var d=document.createElement('div');
    d.className='nz-cod';
    d.innerHTML='<strong>Cash on delivery across Egypt.</strong> The courier calls before delivery — you pay at your door, only once you are satisfied.';
    buy.parentNode.insertBefore(d,buy.nextSibling);
  }
  function arrangeMobile(){
    if(!drawer)return;
    var recs=drawer.querySelector('.nz-cd__recs');
    var cart=drawer.querySelector('.nz-cd__cart');
    var footer=drawer.querySelector('.nz-cd__footer');
    if(!recs||!cart||!footer)return;
    if(window.innerWidth<=600){
      if(footer.previousElementSibling!==recs){cart.insertBefore(recs,footer);}
    }else{
      if(drawer.firstElementChild!==recs){drawer.insertBefore(recs,drawer.firstElementChild);}
    }
  }
  function init(){
    injectCod();
    overlay=document.getElementById('nz-cd-overlay');
    drawer=document.getElementById('nz-cd');
    itemsEl=document.getElementById('nz-cd-items');
    subtotalEl=document.getElementById('nz-cd-subtotal');
    recsList=document.getElementById('nz-cd-recs-list');
    if(!drawer)return;
    arrangeMobile();
    window.addEventListener('resize',arrangeMobile);
    overlay.addEventListener('click',close);
    var closeBtn=document.getElementById('nz-cd-close');
    if(closeBtn)closeBtn.addEventListener('click',close);
    var footer=drawer.querySelector('.nz-cd__footer');
    if(footer&&!document.getElementById('nz-cd-continue')){
      var cont=document.createElement('button');
      cont.type='button';cont.id='nz-cd-continue';cont.className='nz-cd__continue';
      cont.textContent='← Continue Shopping';
      cont.addEventListener('click',close);
      footer.appendChild(cont);
    }
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&isOpen)close();});
    document.querySelectorAll('a[href="/cart"]:not(.nz-cd__view-cart),.header__icon--cart,[data-cart-link]').forEach(function(el){
      el.addEventListener('click',function(e){e.preventDefault();fetchAndOpen();});
    });
    var nzVC=drawer.querySelector('.nz-cd__view-cart');
    if(nzVC)nzVC.addEventListener('click',function(e){e.preventDefault();window.location.href='/cart';});
    document.addEventListener('cart:update',onCartUpdate);
    var style=document.createElement('style');
    style.textContent='cart-drawer,cart-notification{display:none!important;}.nz-cd__continue{display:block;width:100%;box-sizing:border-box;margin-top:4px;padding:12px;background:none;border:none;text-align:center;font-family:var(--font-body--family,Inter,sans-serif);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#1a1a1a;text-decoration:underline;text-underline-offset:3px;cursor:pointer;min-height:44px;-webkit-tap-highlight-color:transparent;}.nz-cd__continue:hover{color:#888;}.nz-cd__close{min-width:40px;min-height:40px;}';
    document.head.appendChild(style);
  }
  function onCartUpdate(e){
    var cart=e&&e.detail&&e.detail.resource;
    if(cart&&cart.items){renderCart(cart);renderRecs();open();}
    else{fetchAndOpen();}
  }
  function fetchAndOpen(){fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){renderCart(cart);renderRecs();open();});}
  function renderCart(cart){
    if(!itemsEl)return;
    if(!cart.items||cart.items.length===0){itemsEl.innerHTML='<p class="nz-cd__empty">Your cart is empty</p>';if(subtotalEl)subtotalEl.textContent='';return;}
    var html='';
    cart.items.forEach(function(item){
      var img=item.image?('<img src="'+item.image+'" class="nz-cd__item-img" alt="'+item.product_title+'" loading="lazy">'):'<div class="nz-cd__item-img"></div>';
      var variant=(item.variant_title&&item.variant_title!=='Default Title')?'<p class="nz-cd__item-variant">'+item.variant_title+'</p>':'';
      html+='<div class="nz-cd__item">'+img+'<div class="nz-cd__item-info"><p class="nz-cd__item-title">'+item.product_title+'</p>'+variant+'<div class="nz-cd__item-row"><div class="nz-cd__item-qty"><button class="nz-cd__qty-btn" data-action="dec" data-key="'+item.key+'" data-qty="'+item.quantity+'" aria-label="Decrease">−</button><span class="nz-cd__qty-val">'+item.quantity+'</span><button class="nz-cd__qty-btn" data-action="inc" data-key="'+item.key+'" data-qty="'+item.quantity+'" aria-label="Increase">+</button></div><span class="nz-cd__item-price">'+fmt(item.line_price)+'</span></div></div><button class="nz-cd__item-remove" data-key="'+item.key+'" aria-label="Remove">×</button></div>';
    });
    itemsEl.innerHTML=html;
    if(subtotalEl)subtotalEl.textContent=fmt(cart.total_price);
    itemsEl.querySelectorAll('.nz-cd__qty-btn').forEach(function(btn){
      btn.addEventListener('click',function(){var key=this.dataset.key,qty=parseInt(this.dataset.qty),newQty=this.dataset.action==='inc'?qty+1:Math.max(0,qty-1);updateItem(key,newQty);});
    });
    itemsEl.querySelectorAll('.nz-cd__item-remove').forEach(function(btn){
      btn.addEventListener('click',function(){updateItem(this.dataset.key,0);});
    });
  }
  function updateItem(key,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(renderCart);}
  function renderRecs(){
    if(!recsList)return;
    var recs=window.nzRecs||[];
    if(recs.length===0){recsList.innerHTML='<p class="nz-cd__rec-empty">Explore more</p>';return;}
    var html='';
    recs.forEach(function(r){
      var img=r.i?('<img src="'+r.i+'" class="nz-cd__rec-img" alt="'+r.t+'" loading="lazy">'):'<div class="nz-cd__rec-img"></div>';
      html+='<a href="'+r.u+'" class="nz-cd__rec-item">'+img+'<div class="nz-cd__rec-info"><p class="nz-cd__rec-name">'+r.t+'</p><p class="nz-cd__rec-price">'+r.p+'</p><span class="nz-cd__rec-cta">Choose options</span></div></a>';
    });
    recsList.innerHTML=html;
  }
  function open(){arrangeMobile();isOpen=true;overlay.classList.add('nz-cd--open');drawer.classList.add('nz-cd--open');document.body.style.overflow='';document.documentElement.style.overflow='';}
  function close(){isOpen=false;overlay.classList.remove('nz-cd--open');drawer.classList.remove('nz-cd--open');document.body.style.overflow='';document.documentElement.style.overflow='';}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();